import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useState } from 'react';
import { useWorkersService } from '@restworld/data-services';
export var useMediaFileUpload = function useMediaFileUpload() {
  var workerService = useWorkersService();

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var uploadFile = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var file, type, resp;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file = _ref.file, type = _ref.type;
              setLoading(true);
              _context.prev = 2;
              _context.next = 5;
              return workerService.sendAsset({
                file: file,
                type: type
              });

            case 5:
              resp = _context.sent;
              setLoading(false);
              return _context.abrupt("return", resp.data);

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error("error uploading file", _context.t0);
              setLoading(false);
              return _context.abrupt("return", null);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [workerService]);

  var deleteUploadedFile = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
      var resp;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.prev = 1;
              _context2.next = 4;
              return workerService.deleteAsset(_objectSpread({}, payload));

            case 4:
              resp = _context2.sent;
              setLoading(false);
              return _context2.abrupt("return", resp.data);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);
              console.error("error deleting file", _context2.t0);
              setLoading(false);
              return _context2.abrupt("return", null);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    }));

    return function deleteUploadedFile(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    uploadFile: uploadFile,
    deleteUploadedFile: deleteUploadedFile,
    loading: loading
  };
};